import { VisualStyle } from "./types/generic";

export type ContentType = {
  id: string;
  name: string;
};

export const CONTENT_TYPES: ContentType[] = [
  { id: "youtube-video", name: "YouTube Video" },
  { id: "youtube-shorts", name: "YouTube Shorts" },
  { id: "instagram-post", name: "Instagram Post" },
  { id: "instagram-reel", name: "Instagram Reel" },
  { id: "facebook-post", name: "Facebook Post" },
  { id: "facebook-video", name: "Facebook Video" },
  { id: "tiktok-video", name: "TikTok Video" },
];

export const thumbnailVisualStyles = [
  { id: "realistic", name: "Realistic", emoji: "📸" },
  { id: "cinematic", name: "Cinematic", emoji: "🎬" },
  { id: "vibrant", name: "Vibrant", emoji: "🌈" },
  { id: "minimalist", name: "Minimalist", emoji: "✨" },
  { id: "dramatic", name: "Dramatic", emoji: "🎭" },
  { id: "neon", name: "Neon", emoji: "🌟" },
] as { id: VisualStyle; name: string; emoji: string }[];
